import { capitalizeFirstLetter } from 'utils/formattingUtil';

import { IAddLanguagesTableData, ILanguageTableRow } from './AddedLanguagesTable.types';

export const mergeLanguageRows = (languagesList: IAddLanguagesTableData[]): ILanguageTableRow[] => {
  return languagesList.reduce(
    (accumulator, currentItem: IAddLanguagesTableData, index) => {
      const existingLanguage = accumulator.find(
        (item: ILanguageTableRow) => item.language === currentItem.language
      );

      if (existingLanguage) {
        existingLanguage._id = index.toString();
        existingLanguage.country = [
          ...existingLanguage.country,
          currentItem.country
        ];
        existingLanguage.countryCode = [
          ...existingLanguage.countryCode,
          currentItem.countryCode
        ];
        existingLanguage.isEnabled = existingLanguage.isEnabled || (currentItem.isEnabled ?? false);
        existingLanguage.isoCode = currentItem.isoCode;
      } else {
        accumulator.push({
          ...currentItem,
          country: [currentItem.country],
          countryCode: [currentItem.countryCode],
          isEnabled: currentItem.isEnabled ?? false,
          isoCode: currentItem.isoCode,
          _id: index.toString()
        });
      }

      return accumulator;
    },
    [] as ILanguageTableRow[]
  );
};

export const formatCountryTooltip = (countries: string[]): string => {
  if (countries.length > 1) {
    return countries
      .map((item: string) => capitalizeFirstLetter(item.toLowerCase()))
      .join(', ');
  }

  return countries[0] ?? '';
};
